import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-153972d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "history-chart" }
const _hoisted_3 = { class: "chart-container" }

import {
  ref,
  onMounted,
  watch,
  onUnmounted,
} from 'vue'
import * as echarts from 'echarts'
import { getLineColor } from '@/utils'
import {
  queryDeviceChartPhysicsHistory,
  queryDeviceChartRealTimePhysicsHistory,
} from '@/api'
import { CODE_ENUM } from '@/common/enum'
import { cloneDeep, set, get, isEmpty } from 'lodash'
import moment from 'moment'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'history-chart',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-map-change'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




const varOps: any = ref([])

const formRef = ref()

const formData = ref({
  time: [],
  limit: 10000,
  frequency: 'D',
  statisticsType: 'MAX-MIN',
})

const DATA_TYPE = {
  REAL: 'REAL',
  AGGREGATED: 'AGGREGATED',
}
const activeName = ref(DATA_TYPE.REAL)

const step = [
  // {
  //   label: t('STATISTICS.minute'),
  //   value: 'N',
  // },
  {
    label: t('STATISTICS.h'),
    value: 'H',
  },
  {
    label: t('STATISTICS.d'),
    value: 'D',
  },
  {
    label: t('STATISTICS.month'),
    value: 'M',
  },
  {
    label: t('STATISTICS.y'),
    value: 'Y',
  },
]

const condition = [
  {
    label: t('STATISTICS.condition1'),
    value: 'MAX-MIN',
  },
  {
    label: t('STATISTICS.condition2'),
    value: 'MAX',
  },
  {
    label: t('STATISTICS.condition3'),
    value: 'MIN',
  },
  {
    label: t('STATISTICS.condition4'),
    value: 'AVG',
  },
  {
    label: t('STATISTICS.condition5'),
    value: 'SUM',
  },
  {
    label: t('STATISTICS.condition6'),
    value: 'COUNT',
  },
  {
    label: t('STATISTICS.condition7'),
    value: 'DIF',
  },
]

const timeValidator = (rule: any, value: any, callback: any) => {
  if (isEmpty(value)) {
    callback()
  } else {
    const [start, end] = value
    if (
      moment(end).valueOf() - moment(start).valueOf() >
      1000 * 60 * 60 * 24 * 367
    ) {
      callback(t('STATISTICS.msgRangeTime'))
    } else {
      callback()
    }
  }
}
const rules: any = {
  time: [
    { required: true, type: 'array', message: t('STATISTICS.select') },
    { validator: timeValidator },
  ],
  limit: { required: true, type: 'number', essage: t('STATISTICS.enter') },
  frequency: { required: true, essage: t('STATISTICS.select') },
  statisticsType: { required: true, essage: t('STATISTICS.select') },
}

watch(
  () => props.data,
  () => {
    const { time } = props.data
    formData.value = {
      ...formData.value,
      time,
    }
    queryData()
  },
  {
    deep: true,
  }
)

const getDate = (month: number, unit: any) => {
  const current = moment().format('YYYY-MM-DD')
  const preDate = moment(current).subtract(month, unit).format('YYYY-MM-DD')
  return [
    new Date(moment(preDate + ' 00:00:00').valueOf()),
    new Date(moment(current + ' 23:59:59').valueOf()),
  ]
}

const shortcuts = [
  {
    text: t('COMMON.timeSelect1'),
    value: getDate(1, 'D'),
  },
  {
    text: t('COMMON.timeSelect2'),
    value: getDate(1, 'M'),
  },
  {
    text: t('COMMON.timeSelect3'),
    value: getDate(3, 'M'),
  },
  {
    text: t('COMMON.timeSelect4'),
    value: getDate(6, 'M'),
  },
  {
    text: t('COMMON.timeSelect5'),
    value: getDate(12, 'M'),
  },
]

const handleClose = () => {
  $emit('update:visible', false)
  formData.value = {
    time: [],
    limit: 10000,
    frequency: 'D',
    statisticsType: 'MAX-MIN',
  }
  activeName.value = DATA_TYPE.REAL
}

onMounted(() => {
  window.addEventListener('resize', resizeCharts)
})

onUnmounted(() => {
  window.removeEventListener('resize', resizeCharts)
})

const clearChart = () => {
  myChart?.clear?.()
  myChart?.dispose?.()
  myChart = null
}

const resizeCharts = () => {
  myChart?.resize?.()
}

const option = {
  title: {
    left: 20,
    top: 20,
  },
  grid: {
    left: 65,
    right: 50,
    top: 70,
    bottom: 30,
  },
  legend: {
    right: 30,
    top: 10,
  },
  tooltip: {
    trigger: 'axis',
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        inside: false,
        color: '#4E5969',
        align: 'center',
        margin: 13,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          type: 'solid',
          color: '#F2F3F5',
        },
      },
    },
  ],
  yAxis: [
    {
      name: '',
      nameTextStyle: {
        padding: [0, 0, 20, 0],
        fontSize: 14,
        align: 'center',
      },
      type: 'value',
      axisLabel: {
        color: '#4E5969',
      },
      splitLine: {
        lineStyle: {
          type: 'solid',
          color: '#F2F3F5',
        },
        show: true,
      },
    },
  ],
  series: [],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    valid && queryData()
  })
}

const deviceRef = ref()
const loading = ref(false)
let myChart: any = null
const queryData = async () => {
  loading.value = true

  const { attributeIndexAndDeviceId } = props.data
  const { time, limit, frequency, statisticsType } = formData.value

  const params =
    activeName.value === DATA_TYPE.REAL
      ? { limit }
      : { frequency, statisticsType }
  const [start, end] = time || []

  const fn =
    activeName.value === DATA_TYPE.REAL
      ? queryDeviceChartRealTimePhysicsHistory
      : queryDeviceChartPhysicsHistory
  const res: any = await fn({
    attributeIndexAndDeviceId,
    endTime: moment(end).valueOf(),
    startTime: moment(start).valueOf(),
    ...params,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { pointStatisticsMap = {} } = res.data || {}

    const keys = Object.keys(pointStatisticsMap)

    let moXaxis = null
    let moFormatter = ''
    const series = keys.map((key: string, index: number) => {
      const { xaxis, yaxis, config, formatter } = pointStatisticsMap[key]
      moXaxis = xaxis
      moFormatter = formatter
      return {
        data: yaxis,
        type: 'line',
        ...config,
        ...getLineColor(index),
        // 不让断开
        connectNulls: true,
        showAllSymbol: true,
      }
    })

    const seriesData = series.map((item: any) => item.data)
    if (isEmptyData(seriesData.flat(Infinity))) {
      clearChart()
      return
    }

    const ops = cloneDeep(option)

    set(ops, 'tooltip.valueFormatter', tooltipFomatter(moFormatter))
    // set(ops, 'yAxis[0].axisLabel.formatter', '{value} ' + moFormatter)
    set(ops, 'series', series)
    set(ops, 'xAxis[0].data', moXaxis)
    set(ops, 'yAxis[0].name', moFormatter)

    clearChart()
    myChart = echarts.init(deviceRef.value)
    showEmpty.value = false
    myChart.setOption(ops)
  } else if (res?.code === 30900) {
    showEmpty.value = true
    clearChart()
  }
}

const showEmpty = ref(false)
const isEmptyData = (list: any) => {
  const reslut = list.filter((data: any) => data !== null).length === 0
  showEmpty.value = reslut
  return reslut
}

const tooltipFomatter = (formatter: string) => {
  return (value: string) => {
    return value !== null && value !== undefined ? value + formatter : '-'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: _ctx.$t('STATISTICS.chartTitle'),
    width: "1229",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          type: "card",
          class: "demo-tabs",
          onTabChange: queryData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('STATISTICS.realData'),
              name: DATA_TYPE.REAL
            }, null, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('STATISTICS.aggregatedData'),
              name: DATA_TYPE.AGGREGATED
            }, null, 8, ["label", "name"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "ws_mt15",
          model: formData.value,
          rules: rules,
          inline: true
        }, {
          default: _withCtx(() => [
            (DATA_TYPE.REAL === activeName.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$t('STATISTICS.maximum'),
                  prop: "limit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: formData.value.limit,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.limit) = $event)),
                      min: 1,
                      max: 10000,
                      "controls-position": "right",
                      class: "ws_common_number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (DATA_TYPE.AGGREGATED === activeName.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$t('STATISTICS.aggregatedConditions'),
                  prop: "statisticsType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.statisticsType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.statisticsType) = $event)),
                      style: {"width":"150px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (DATA_TYPE.AGGREGATED === activeName.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: _ctx.$t('STATISTICS.timeStep'),
                  prop: "frequency"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.frequency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.frequency) = $event)),
                      style: {"width":"150px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(step, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('STATISTICS.range'),
              prop: "time",
              class: "time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: formData.value.time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.time) = $event)),
                  "unlink-panels": "",
                  type: "datetimerange",
                  "range-separator": "-",
                  "start-placeholder": _ctx.$t('STATISTICS.startTime'),
                  "end-placeholder": _ctx.$t('STATISTICS.endTime'),
                  shortcuts: shortcuts,
                  editable: false
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { style: {"margin-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: submit,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.search')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            ref_key: "deviceRef",
            ref: deviceRef,
            class: "chart-box"
          }, null, 512),
          (showEmpty.value)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: _ctx.$t('STATISTICS.noData'),
                class: "ws_mt50"
              }, null, 8, ["description"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, loading.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})